import {
  FaLaptopCode,
  FaServer,
  FaRobot,
  FaEnvelope,
  FaWhatsapp,
  FaBullhorn,
  FaDesktop,
  FaShieldAlt,
  FaNetworkWired,
  FaCloud,
} from "react-icons/fa";

import { MdOutlineAppShortcut } from "react-icons/md";
import { BsFillCameraVideoFill } from "react-icons/bs";

export const enterpriseSolutions = [
  {
    id: 1,
    icon: FaServer, // or FaMicrochip, FaLaptop, FaNetworkWired
    title: "Hardware Solutions",
    description:
      "Reliable hardware infrastructure and IT equipment to ensure seamless business operations.",
    features: [
      "Server Setup",
      "Networking Solutions",
      "Computer & Laptop Support",
      "IT Infrastructure",
    ],
    gradient: "from-emerald-500 to-teal-600",
  },
  {
    id: 2,
    icon: FaDesktop,
    title: "Software Solutions",
    description:
      "Custom business software to simplify operations and improve productivity.",
    features: [
      "ERP Systems",
      "CRM Solutions",
      "Custom Software",
      "Business Automation",
    ],
    gradient: "from-indigo-500 to-blue-600",
  },

  {
    id: 3,
    icon: FaNetworkWired,
    title: "Network Solutions",
    description:
      "Reliable networking infrastructure for businesses of every size.",
    features: [
      "LAN/WAN",
      "Wi-Fi Solutions",
      "Server Installation",
      "Network Security",
    ],
    gradient: "from-sky-500 to-cyan-500",
  },

  {
    id: 4,
    icon: FaShieldAlt,
    title: "Security Solutions",
    description:
      "Enterprise-grade security systems to protect your infrastructure.",
    features: [
      "CCTV",
      "Access Control",
      "Fire Alarm",
      "Biometric Systems",
    ],
    gradient: "from-red-500 to-orange-500",
  },

  {
    id: 5,
    icon: BsFillCameraVideoFill,
    title: "A/V Solutions",
    description:
      "Professional audio visual solutions for conference rooms and smart workplaces.",
    features: [
      "Video Conferencing",
      "Interactive Displays",
      "Digital Signage",
      "PA Systems",
    ],
    gradient: "from-fuchsia-500 to-purple-600",
  },
  {
    id: 6,
    icon: FaDesktop,
    title: "IT Infrastructure",
    description:
      "Complete IT infrastructure planning, deployment and ongoing support.",
    features: [
      "Server Setup",
      "IT Consulting",
      "Hardware Support",
      "AMC Services",
    ],
    gradient: "from-slate-700 to-slate-900",
  },
];

export const digitalSolutions = [
  {
    id: 1,
    icon: FaLaptopCode,
    title: "Web Development",
    description:
      "Modern, responsive and SEO-friendly websites designed to grow your business.",
    features: [
      "Responsive Design",
      "SEO Optimized",
      "Fast Performance",
      "CMS Integration",
    ],
    gradient: "from-pink-500 to-rose-500",
  },

  {
    id: 2,
    icon: MdOutlineAppShortcut,
    title: "App Development",
    description:
      "Powerful Android and iOS applications with outstanding user experience.",
    features: [
      "Android Apps",
      "iOS Apps",
      "Cross Platform",
      "Modern UI",
    ],
    gradient: "from-cyan-500 to-blue-500",
  },

  {
    id: 3,
    icon: FaRobot,
    title: "AI Automation",
    description:
      "Automate business processes using AI-powered workflows and smart assistants.",
    features: [
      "AI Chatbots",
      "Workflow Automation",
      "AI Agents",
      "CRM Integration",
    ],
    gradient: "from-violet-500 to-purple-600",
  },

  {
    id: 4,
    icon: FaEnvelope,
    title: "Email Marketing",
    description:
      "Generate leads with targeted email campaigns and automation.",
    features: [
      "Campaign Design",
      "Automation",
      "Analytics",
      "Lead Nurturing",
    ],
    gradient: "from-blue-500 to-indigo-600",
  },

  {
    id: 5,
    icon: FaWhatsapp,
    title: "WhatsApp Marketing",
    description:
      "Reach customers instantly with personalized WhatsApp campaigns.",
    features: [
      "Bulk Messaging",
      "Lead Generation",
      "Automation",
      "Customer Support",
    ],
    gradient: "from-green-500 to-emerald-500",
  },

  {
    id: 6,
    icon: FaBullhorn,
    title: "Social Media Marketing",
    description:
      "Build your brand and grow faster across digital platforms.",
    features: [
      "Meta Ads",
      "LinkedIn Marketing",
      "Content Strategy",
      "Brand Growth",
    ],
    gradient: "from-orange-500 to-pink-500",
  },
];

